import {GameState} from '@colonist/game-states'
import React, {ReactNode, createContext, useContext} from 'react'

const UIGameStateContext = createContext<GameState | null>(null)

export function UIGameStateProvider({
    children,
    gameState,
}: {
    children: ReactNode
    gameState: GameState
}) {
    return (
        <UIGameStateContext.Provider value={gameState}>
            {children}
        </UIGameStateContext.Provider>
    )
}

export function useUIGameStateContext() {
    const gameState = useContext(UIGameStateContext)
    if(gameState == null) throw new Error('useGameState must be used within a UIGameStateProvider')

    return gameState
}
